module.exports = "/_next/static/images/rotate-37efd8968de4c1995a4a8e5c6cad794c.png";